export enum BoxSizeEnum {
  small = 'small',
  large = 'large',
}
